import React from 'react'

export default () => {
    return <>404</>
}